import * as React from "react";
import { useRef } from "react";
import styled from "styled-components";
import { PluginStore } from "graylog-web-plugin/plugin";
import InteractiveContext from "views/components/contexts/InteractiveContext";
import WidgetVisualizationNotFound from "components/widgets/WidgetVisualizationNotFound";
import { Spinner } from "components/common";
const LEGEND_HEIGHT = 55;
const Center = styled.div`
  font-size: 70px;
  text-align: center;
  vertical-align: middle;
`;
const setLoadingState = () => {
};
const PrintingWidgetVisualization = ({
  widget,
  widgetId,
  result,
  hasError,
  errorMessage,
  types,
  visualizationHeight,
  width,
  interactive,
  limitHeight
}) => {
  var _a;
  const visualizationRef = useRef();
  if (widget.type === "") {
    return null;
  }
  if (result === void 0) {
    return /* @__PURE__ */ React.createElement(Center, null, /* @__PURE__ */ React.createElement(Spinner, { text: "" }));
  }
  if (result === "N/A") {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Center, null, result), hasError && errorMessage);
  }
  const widgetPlugin = PluginStore.exports("enterpriseWidgets").find(
    (w) => w.type.toUpperCase() === widget.type.toUpperCase()
  );
  if (!widgetPlugin) {
    return /* @__PURE__ */ React.createElement(WidgetVisualizationNotFound, { widgetClassName: widget.type });
  }
  const Visualization = widgetPlugin.visualizationComponent;
  const maxHeight = limitHeight || widgetPlugin.needsControlledHeight(widget) ? visualizationHeight - LEGEND_HEIGHT : (_a = visualizationRef.current) == null ? void 0 : _a.offsetHeight;
  return /* @__PURE__ */ React.createElement(InteractiveContext.Provider, { value: interactive ? "interactive" : "disabled" }, /* @__PURE__ */ React.createElement(
    Visualization,
    {
      id: widgetId,
      config: widget.config,
      editing: false,
      data: result,
      fields: types,
      height: maxHeight,
      width,
      setLoadingState,
      queryId: "reporting-id"
    }
  ));
};
export default PrintingWidgetVisualization;
